import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';

interface BaseItemMultiplyColorOptionProps {
  multiplyColor: RGBA;
  onClickColorFill(): void;
  className?: string;
}

export function BaseItemMultiplyColorOption({className = '', ...props}: BaseItemMultiplyColorOptionProps): ReactElement<any> | null {
  const getColorObject = (): ColorFillStorage[] => {
    return [
      {
        id: 'multiply-color-object',
        color: getColorObjectArrayFromFillColor([props.multiplyColor]),
      },
    ];
  };

  const getMultiplyColorFillObject = (): ReactElement<any> => {
    return (
      <ContextualMenuColorFillOption
        id="item-multiply-color-fill"
        label={window.i18next.t('pmwjs_color')}
        className={className}
        data={getColorObject()}
        onClick={(): void => {
          props.onClickColorFill();
        }}
      />
    );
  };

  return getMultiplyColorFillObject();
}
